import gql from 'graphql-tag';

export default gql`
  mutation Upload($file: Upload, $path: String) {
    upload(file: $file, path: $path) {
      path
    }
  }
`;
